(function () {
  var toast = document.getElementById('Toast');
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    setTimeout(function () { toast.classList.remove('is-visible'); }, 2400);
  }
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  }

  // Add to cart without leaving the page
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-ajax-add]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        setCount(cart.item_count);
        showToast('Added to your cart');
        if (btn) { btn.textContent = 'Added'; }
      })
      .catch(function (err) {
        var go = function (m) { showToast(m || 'Could not add this item'); };
        if (err && err.json) { err.json().then(function (j) { go(j.description); }); } else { go(); }
        if (btn) { btn.textContent = label; }
      })
      .finally(function () {
        setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = label; } }, 1400);
      });
  });

  // Product page: gallery, variants, quantity, sticky add button
  var section = document.querySelector('[data-product-section]');
  if (section) {
    var main = document.getElementById('MainImage');
    section.querySelectorAll('.thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) { main.removeAttribute('srcset'); main.src = t.dataset.large; }
        section.querySelectorAll('.thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    var dataEl = document.getElementById('VariantData');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var selects = section.querySelectorAll('[data-option-index]');
    var idInput = document.getElementById('VariantId');
    var addBtn = document.getElementById('AddBtn');
    var priceEl = document.getElementById('ProductPrice');
    var stickyPrice = document.getElementById('StickyPrice');

    function onVariantChange() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var v = variants.find(function (x) { return x.options.join('|') === chosen.join('|'); });
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      priceEl.innerHTML = (v.compare ? '<s>' + v.compare + '</s> ' : '') + '<span class="' + (v.compare ? 'is-sale' : '') + '">' + v.price + '</span>';
      if (stickyPrice) stickyPrice.textContent = v.price;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u);
    }
    selects.forEach(function (s) { s.addEventListener('change', onVariantChange); });

    var qty = document.getElementById('Qty');
    section.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.qty, 10));
      });
    });

    var sticky = document.getElementById('StickyAtc');
    var form = document.getElementById('ProductForm');
    if (sticky && form && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(addBtn);
      sticky.querySelector('[data-sticky-add]').addEventListener('click', function () {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }
})();
